function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import { h } from 'preact';
import { UIPlugin } from '@uppy/core';
import getFileTypeExtension from '@uppy/utils/lib/getFileTypeExtension';
import mimeTypes from '@uppy/utils/lib/mimeTypes';
import isMobile from 'is-mobile';
import canvasToBlob from '@uppy/utils/lib/canvasToBlob';
import supportsMediaRecorder from "./supportsMediaRecorder.js";
import CameraIcon from "./CameraIcon.js";
import CameraScreen from "./CameraScreen.js";
import PermissionsScreen from "./PermissionsScreen.js";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.4.2"
};
import locale from "./locale.js";

/**
 * Normalize a MIME type or file extension into a MIME type.
 *
 * @param fileType - MIME type or a file extension prefixed with `.`.
 * @returns The MIME type or `undefined` if the fileType is an extension and is not known.
 */
function toMimeType(fileType) {
  if (fileType[0] === '.') {
    return mimeTypes[fileType.slice(1)];
  }
  return fileType;
}

/**
 * Is this MIME type a video?
 */
function isVideoMimeType(mimeType) {
  return /^video\/[^*]+$/.test(mimeType);
}

/**
 * Is this MIME type an image?
 */
function isImageMimeType(mimeType) {
  return /^image\/[^*]+$/.test(mimeType);
}
function getMediaDevices() {
  // bug in the compatibility data
  // eslint-disable-next-line compat/compat
  return navigator.mediaDevices;
}
function isModeAvailable(modes, mode) {
  return modes.includes(mode);
}
// set default options
var defaultOptions = {
  onBeforeSnapshot: function onBeforeSnapshot() {
    return Promise.resolve();
  },
  countdown: false,
  modes: ['video-audio', 'video-only', 'audio-only', 'picture'],
  mirror: true,
  showVideoSourceDropdown: false,
  facingMode: 'user',
  // @TODO: remove in the next major
  preferredImageMimeType: null,
  preferredVideoMimeType: null,
  showRecordingLength: false,
  mobileNativeCamera: isMobile({
    tablet: true
  })
};

/**
 * Webcam
 */
var _enableMirror = /*#__PURE__*/_classPrivateFieldLooseKey("enableMirror");
var Webcam = /*#__PURE__*/function (_UIPlugin) {
  _inherits(Webcam, _UIPlugin);
  function Webcam(uppy, opts) {
    var _this;
    _classCallCheck(this, Webcam);
    _this = _callSuper(this, Webcam, [uppy, _objectSpread(_objectSpread({}, defaultOptions), opts)]);
    // enableMirror is used to toggle mirroring, for instance when discarding the video,
    // while `opts.mirror` is used to remember the initial user setting
    Object.defineProperty(_assertThisInitialized(_this), _enableMirror, {
      writable: true,
      value: void 0
    });
    _this.mediaDevices = getMediaDevices();
    _this.supportsUserMedia = !!_this.mediaDevices;
    // eslint-disable-next-line no-restricted-globals
    _this.protocol = location.protocol.match(/https/i) ? 'https' : 'http';
    _this.id = _this.opts.id || 'Webcam';
    _this.type = 'acquirer';
    _this.capturedMediaFile = null;
    _this.icon = function () {
      return h("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, h("path", {
        d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
        fill: "#02B383",
        fillRule: "nonzero"
      }));
    };
    _this.defaultLocale = locale;
    _this.i18nInit();
    _this.title = _this.i18n('pluginNameCamera');
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _enableMirror)[_enableMirror] = _this.opts.mirror;
    _this.install = _this.install.bind(_assertThisInitialized(_this));
    _this.setPluginState = _this.setPluginState.bind(_assertThisInitialized(_this));
    _this.render = _this.render.bind(_assertThisInitialized(_this));

    // Camera controls
    _this.start = _this.start.bind(_assertThisInitialized(_this));
    _this.stop = _this.stop.bind(_assertThisInitialized(_this));
    _this.takeSnapshot = _this.takeSnapshot.bind(_assertThisInitialized(_this));
    _this.startRecording = _this.startRecording.bind(_assertThisInitialized(_this));
    _this.stopRecording = _this.stopRecording.bind(_assertThisInitialized(_this));
    _this.discardRecordedVideo = _this.discardRecordedVideo.bind(_assertThisInitialized(_this));
    _this.submit = _this.submit.bind(_assertThisInitialized(_this));
    _this.oneTwoThreeSmile = _this.oneTwoThreeSmile.bind(_assertThisInitialized(_this));
    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
    _this.changeVideoSource = _this.changeVideoSource.bind(_assertThisInitialized(_this));
    _this.webcamActive = false;
    if (_this.opts.countdown) {
      _this.opts.onBeforeSnapshot = _this.oneTwoThreeSmile;
    }
    _this.setPluginState({
      hasCamera: false,
      cameraReady: false,
      cameraError: null,
      recordingLengthSeconds: 0,
      videoSources: [],
      currentDeviceId: null
    });
    return _this;
  }
  _createClass(Webcam, [{
    key: "setOptions",
    value: function setOptions(newOpts) {
      _get(_getPrototypeOf(Webcam.prototype), "setOptions", this).call(this, _objectSpread(_objectSpread({}, newOpts), {}, {
        videoConstraints: _objectSpread(_objectSpread({}, this.opts.videoConstraints), newOpts == null ? void 0 : newOpts.videoConstraints)
      }));
    }
  }, {
    key: "hasCameraCheck",
    value: function hasCameraCheck() {
      if (!this.mediaDevices) {
        return Promise.resolve(false);
      }
      return this.mediaDevices.enumerateDevices().then(function (devices) {
        return devices.some(function (device) {
          return device.kind === 'videoinput';
        });
      });
    }
  }, {
    key: "isAudioOnly",
    value: function isAudioOnly() {
      return this.opts.modes.length === 1 && this.opts.modes[0] === 'audio-only';
    }
  }, {
    key: "getConstraints",
    value: function getConstraints(deviceId) {
      if (deviceId === void 0) {
        deviceId = null;
      }
      var acceptsAudio = this.opts.modes.indexOf('video-audio') !== -1 || this.opts.modes.indexOf('audio-only') !== -1;
      var acceptsVideo = !this.isAudioOnly() && (this.opts.modes.indexOf('video-audio') !== -1 || this.opts.modes.indexOf('video-only') !== -1 || this.opts.modes.indexOf('picture') !== -1);
      var videoConstraints = _objectSpread(_objectSpread({}, this.opts.videoConstraints || {
        facingMode: this.opts.facingMode
      }), deviceId ? {
        deviceId: deviceId,
        facingMode: null
      } : {});
      return {
        audio: acceptsAudio,
        video: acceptsVideo ? videoConstraints : false
      };
    }

    // eslint-disable-next-line consistent-return
  }, {
    key: "start",
    value: function start(options) {
      var _this2 = this;
      var _options;
      if (options === void 0) {
        options = null;
      }
      if (!this.supportsUserMedia) {
        return Promise.reject(new Error('Webcam access not supported'));
      }
      this.webcamActive = true;
      if (this.opts.mirror) {
        _classPrivateFieldLooseBase(this, _enableMirror)[_enableMirror] = true;
      }
      var constraints = this.getConstraints((_options = options) == null ? void 0 : _options.deviceId);

      // TODO: add a return and/or convert this to async/await
      this.hasCameraCheck().then(function (hasCamera) {
        _this2.setPluginState({
          hasCamera: hasCamera
        });

        // ask user for access to their camera
        return _this2.mediaDevices.getUserMedia(constraints).then(function (stream) {
          _this2.stream = stream;
          var currentDeviceId = null;
          var tracks = _this2.isAudioOnly() ? stream.getAudioTracks() : stream.getVideoTracks();
          if (!options || !options.deviceId) {
            currentDeviceId = tracks[0].getSettings().deviceId;
          } else {
            tracks.forEach(function (track) {
              if (track.getSettings().deviceId === options.deviceId) {
                currentDeviceId = track.getSettings().deviceId;
              }
            });
          }

          // Update the sources now, so we can access the names.
          _this2.updateVideoSources();
          _this2.setPluginState({
            currentDeviceId: currentDeviceId,
            cameraReady: true
          });
        }).catch(function (err) {
          _this2.setPluginState({
            cameraReady: false,
            cameraError: err
          });
          _this2.uppy.info(err.message, 'error');
        });
      });
    }
  }, {
    key: "getMediaRecorderOptions",
    value: function getMediaRecorderOptions() {
      var options = {};

      // Try to use the `opts.preferredVideoMimeType` or one of the `allowedFileTypes` for the recording.
      // If the browser doesn't support it, we'll fall back to the browser default instead.
      // Safari doesn't have the `isTypeSupported` API.
      if (MediaRecorder.isTypeSupported) {
        var restrictions = this.uppy.opts.restrictions;
        var preferredVideoMimeTypes = [];
        if (this.opts.preferredVideoMimeType) {
          preferredVideoMimeTypes = [this.opts.preferredVideoMimeType];
        } else if (restrictions.allowedFileTypes) {
          preferredVideoMimeTypes = restrictions.allowedFileTypes.map(toMimeType).filter(isVideoMimeType);
        }
        var filterSupportedTypes = function filterSupportedTypes(candidateType) {
          return MediaRecorder.isTypeSupported(candidateType) && getFileTypeExtension(candidateType);
        };
        var acceptableMimeTypes = preferredVideoMimeTypes.filter(filterSupportedTypes);
        if (acceptableMimeTypes.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          options.mimeType = acceptableMimeTypes[0];
        }
      }
      return options;
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      var _this3 = this;
      // only used if supportsMediaRecorder() returned true
      // eslint-disable-next-line compat/compat
      this.recorder = new MediaRecorder(this.stream, this.getMediaRecorderOptions());
      this.recordingChunks = [];
      var stoppingBecauseOfMaxSize = false;
      this.recorder.addEventListener('dataavailable', function (event) {
        _this3.recordingChunks.push(event.data);
        var restrictions = _this3.uppy.opts.restrictions;
        if (_this3.recordingChunks.length > 1 && restrictions.maxFileSize != null && !stoppingBecauseOfMaxSize) {
          var totalSize = _this3.recordingChunks.reduce(function (acc, chunk) {
            return acc + chunk.size;
          }, 0);
          // Exclude the initial chunk from the average size calculation because it is likely to be a very small outlier
          var averageChunkSize = (totalSize - _this3.recordingChunks[0].size) / (_this3.recordingChunks.length - 1);
          var expectedEndChunkSize = averageChunkSize * 3;
          var maxSize = Math.max(0, restrictions.maxFileSize - expectedEndChunkSize);
          if (totalSize > maxSize) {
            stoppingBecauseOfMaxSize = true;
            _this3.uppy.info(_this3.i18n('recordingStoppedMaxSize'), 'warning', 4000);
            _this3.stopRecording();
          }
        }
      });

      // use a "time slice" of 500ms: ondataavailable will be called each 500ms
      // smaller time slices mean we can more accurately check the max file size restriction
      this.recorder.start(500);
      if (this.opts.showRecordingLength) {
        // Start the recordingLengthTimer if we are showing the recording length.
        this.recordingLengthTimer = setInterval(function () {
          var currentRecordingLength = _this3.getPluginState().recordingLengthSeconds;
          _this3.setPluginState({
            recordingLengthSeconds: currentRecordingLength + 1
          });
        }, 1000);
      }
      this.setPluginState({
        isRecording: true
      });
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      var _this4 = this;
      var stopped = new Promise(function (resolve) {
        _this4.recorder.addEventListener('stop', function () {
          resolve();
        });
        _this4.recorder.stop();
        if (_this4.opts.showRecordingLength) {
          // Stop the recordingLengthTimer if we are showing the recording length.
          clearInterval(_this4.recordingLengthTimer);
          _this4.setPluginState({
            recordingLengthSeconds: 0
          });
        }
      });
      return stopped.then(function () {
        _this4.setPluginState({
          isRecording: false
        });
        return _this4.getVideo();
      }).then(function (file) {
        try {
          _this4.capturedMediaFile = file;
          // create object url for capture result preview
          _this4.setPluginState({
            // eslint-disable-next-line compat/compat
            recordedVideo: URL.createObjectURL(file.data)
          });
          _classPrivateFieldLooseBase(_this4, _enableMirror)[_enableMirror] = false;
        } catch (err) {
          // Logging the error, exept restrictions, which is handled in Core
          if (!err.isRestriction) {
            _this4.uppy.log(err);
          }
        }
      }).then(function () {
        _this4.recordingChunks = null;
        _this4.recorder = null;
      }, function (error) {
        _this4.recordingChunks = null;
        _this4.recorder = null;
        throw error;
      });
    }
  }, {
    key: "discardRecordedVideo",
    value: function discardRecordedVideo() {
      this.setPluginState({
        recordedVideo: null
      });
      if (this.opts.mirror) {
        _classPrivateFieldLooseBase(this, _enableMirror)[_enableMirror] = true;
      }
      this.capturedMediaFile = null;
    }
  }, {
    key: "submit",
    value: function submit() {
      try {
        if (this.capturedMediaFile) {
          this.uppy.addFile(this.capturedMediaFile);
        }
      } catch (err) {
        // Logging the error, exept restrictions, which is handled in Core
        if (!err.isRestriction) {
          this.uppy.log(err, 'error');
        }
      }
    }
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this5 = this;
        var audioTracks, videoTracks;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.stream) {
                audioTracks = this.stream.getAudioTracks();
                videoTracks = this.stream.getVideoTracks();
                audioTracks.concat(videoTracks).forEach(function (track) {
                  return track.stop();
                });
              }
              if (!this.recorder) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return new Promise(function (resolve) {
                _this5.recorder.addEventListener('stop', resolve, {
                  once: true
                });
                _this5.recorder.stop();
                if (_this5.opts.showRecordingLength) {
                  clearInterval(_this5.recordingLengthTimer);
                }
              });
            case 4:
              this.recordingChunks = null;
              this.recorder = null;
              this.webcamActive = false;
              this.stream = null;
              this.setPluginState({
                recordedVideo: null,
                isRecording: false,
                recordingLengthSeconds: 0
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }, {
    key: "getVideoElement",
    value: function getVideoElement() {
      return this.el.querySelector('.uppy-Webcam-video');
    }
  }, {
    key: "oneTwoThreeSmile",
    value: function oneTwoThreeSmile() {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        var count = _this6.opts.countdown;

        // eslint-disable-next-line consistent-return
        var countDown = setInterval(function () {
          if (!_this6.webcamActive) {
            clearInterval(countDown);
            _this6.captureInProgress = false;
            return reject(new Error('Webcam is not active'));
          }
          if (count) {
            _this6.uppy.info("".concat(count, "..."), 'warning', 800);
            count--;
          } else {
            clearInterval(countDown);
            _this6.uppy.info(_this6.i18n('smile'), 'success', 1500);
            setTimeout(function () {
              return resolve();
            }, 1500);
          }
        }, 1000);
      });
    }
  }, {
    key: "takeSnapshot",
    value: function takeSnapshot() {
      var _this7 = this;
      if (this.captureInProgress) return;
      this.captureInProgress = true;
      this.opts.onBeforeSnapshot().catch(function (err) {
        var message = _typeof(err) === 'object' ? err.message : err;
        _this7.uppy.info(message, 'error', 5000);
        return Promise.reject(new Error("onBeforeSnapshot: ".concat(message)));
      }).then(function () {
        return _this7.getImage();
      }).then(function (tagFile) {
        _this7.captureInProgress = false;
        try {
          _this7.uppy.addFile(tagFile);
        } catch (err) {
          // Logging the error, except restrictions, which is handled in Core
          if (!err.isRestriction) {
            _this7.uppy.log(err);
          }
        }
      }, function (error) {
        _this7.captureInProgress = false;
        throw error;
      });
    }
  }, {
    key: "getImage",
    value: function getImage() {
      var _this8 = this;
      var video = this.getVideoElement();
      if (!video) {
        return Promise.reject(new Error('No video element found, likely due to the Webcam tab being closed.'));
      }
      var width = video.videoWidth;
      var height = video.videoHeight;
      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);
      var restrictions = this.uppy.opts.restrictions;
      var preferredImageMimeTypes = [];
      if (this.opts.preferredImageMimeType) {
        preferredImageMimeTypes = [this.opts.preferredImageMimeType];
      } else if (restrictions.allowedFileTypes) {
        preferredImageMimeTypes = restrictions.allowedFileTypes.map(toMimeType).filter(isImageMimeType);
      }
      var mimeType = preferredImageMimeTypes[0] || 'image/jpeg';
      var ext = getFileTypeExtension(mimeType) || 'jpg';
      var name = "cam-".concat(Date.now(), ".").concat(ext);
      return canvasToBlob(canvas, mimeType).then(function (blob) {
        return {
          source: _this8.id,
          name: name,
          data: new Blob([blob], {
            type: mimeType
          }),
          type: mimeType
        };
      });
    }
  }, {
    key: "getVideo",
    value: function getVideo() {
      // Sometimes in iOS Safari, Blobs (especially the first Blob in the recordingChunks Array)
      // have empty 'type' attributes (e.g. '') so we need to find a Blob that has a defined 'type'
      // attribute in order to determine the correct MIME type.
      var mimeType = this.recordingChunks.find(function (blob) {
        var _blob$type;
        return ((_blob$type = blob.type) == null ? void 0 : _blob$type.length) > 0;
      }).type;
      var fileExtension = getFileTypeExtension(mimeType);
      if (!fileExtension) {
        return Promise.reject(new Error("Could not retrieve recording: Unsupported media type \"".concat(mimeType, "\"")));
      }
      var name = "webcam-".concat(Date.now(), ".").concat(fileExtension);
      var blob = new Blob(this.recordingChunks, {
        type: mimeType
      });
      var file = {
        source: this.id,
        name: name,
        data: new Blob([blob], {
          type: mimeType
        }),
        type: mimeType
      };
      return Promise.resolve(file);
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this9 = this;
      if (!this.opts.countdown) return;
      setTimeout(function () {
        _this9.uppy.info(_this9.i18n('smile'), 'success', 1500);
      }, 1000);
    }
  }, {
    key: "changeVideoSource",
    value: function changeVideoSource(deviceId) {
      this.stop();
      this.start({
        deviceId: deviceId
      });
    }
  }, {
    key: "updateVideoSources",
    value: function updateVideoSources() {
      var _this10 = this;
      this.mediaDevices.enumerateDevices().then(function (devices) {
        _this10.setPluginState({
          videoSources: devices.filter(function (device) {
            return device.kind === 'videoinput';
          })
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.webcamActive) {
        this.start();
      }
      var webcamState = this.getPluginState();
      if (!webcamState.cameraReady || !webcamState.hasCamera) {
        return h(PermissionsScreen, {
          icon: CameraIcon,
          i18n: this.i18n,
          hasCamera: webcamState.hasCamera
        });
      }
      return h(CameraScreen
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, webcamState, {
        onChangeVideoSource: this.changeVideoSource,
        onSnapshot: this.takeSnapshot,
        onStartRecording: this.startRecording,
        onStopRecording: this.stopRecording,
        onDiscardRecordedVideo: this.discardRecordedVideo,
        onSubmit: this.submit,
        onFocus: this.focus,
        onStop: this.stop,
        i18n: this.i18n,
        modes: this.opts.modes,
        showRecordingLength: this.opts.showRecordingLength,
        showVideoSourceDropdown: this.opts.showVideoSourceDropdown,
        supportsRecording: supportsMediaRecorder(),
        recording: webcamState.isRecording,
        mirror: _classPrivateFieldLooseBase(this, _enableMirror)[_enableMirror],
        src: this.stream
      }));
    }
  }, {
    key: "install",
    value: function install() {
      var _this11 = this;
      var _this$opts = this.opts,
        mobileNativeCamera = _this$opts.mobileNativeCamera,
        modes = _this$opts.modes,
        facingMode = _this$opts.facingMode,
        videoConstraints = _this$opts.videoConstraints;
      var target = this.opts.target;
      if (mobileNativeCamera && target) {
        var _this$getTargetPlugin;
        (_this$getTargetPlugin = this.getTargetPlugin(target)) == null || _this$getTargetPlugin.setOptions({
          showNativeVideoCameraButton: isModeAvailable(modes, 'video-only') || isModeAvailable(modes, 'video-audio'),
          showNativePhotoCameraButton: isModeAvailable(modes, 'picture'),
          nativeCameraFacingMode: (videoConstraints == null ? void 0 : videoConstraints.facingMode) || facingMode
        });
        return;
      }
      this.setPluginState({
        cameraReady: false,
        recordingLengthSeconds: 0
      });
      if (target) {
        this.mount(target, this);
      }
      if (this.mediaDevices) {
        this.updateVideoSources();
        this.mediaDevices.ondevicechange = function () {
          _this11.updateVideoSources();
          if (_this11.stream) {
            var restartStream = true;
            var _this11$getPluginStat = _this11.getPluginState(),
              videoSources = _this11$getPluginStat.videoSources,
              currentDeviceId = _this11$getPluginStat.currentDeviceId;
            videoSources.forEach(function (videoSource) {
              if (currentDeviceId === videoSource.deviceId) {
                restartStream = false;
              }
            });
            if (restartStream) {
              _this11.stop();
              _this11.start();
            }
          }
        };
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.stop();
      this.unmount();
    }
  }, {
    key: "onUnmount",
    value: function onUnmount() {
      this.stop();
    }
  }]);
  return Webcam;
}(UIPlugin);
export { Webcam as default };
Webcam.VERSION = packageJson.version;